// extracted by mini-css-extract-plugin
var _1 = "TabsFormValueItem_actions__04be4";
var _2 = "TabsFormValueItem_active__d7104";
var _3 = "TabsFormValueItem_header__23c75";
var _4 = "TabsFormValueItem_root__ddd2a";
var _5 = "TabsFormValueItem_title__6c672";
export { _1 as "actions", _2 as "active", _3 as "header", _4 as "root", _5 as "title" }
